import React, { useEffect, useState } from 'react';
import { observer } from "mobx-react-lite";
import { withRouter } from "react-router-dom";
import {Avatar, Box, Button, ListItemIcon, ListItemText, Skeleton, Typography} from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';
import { getUserObject, isAdmin, signUserOut } from '../../actions/profile/UserActions';
import { getSiteByIdForUser } from '../../actions/internal/SiteActions';
import StyledLogo from "../common/StyledLogo";
import {DesktopBox, MobileBox} from "../common/Boxes";
import {PROFILE_FONT_STYLE} from "../../constants/Styles";
import { getUserId } from '../../selectors/UserSelectors';
import { getEnv, getLocalEnv, isLocalStage } from '../../config';
import { INTERNAL_HEADER_HEIGHT } from '../../constants/Constants';
import { getAllSites } from '../../selectors/SiteSelectors';
import { AccountCircleOutlined, LogoutOutlined, PersonOutline, StoreOutlined } from '@mui/icons-material';
import { setIsDrawerOpen } from '../../actions/internal/MenuActions';
import MenuStore from '../../stores/internal/MenuStore';

const InternalHeader = ({ history, location, parentIsLoading }) => {

  const [ anchorEl, setAnchorEl ] = useState();
  const [ isLoadingSite, setIsLoadingSite ] = useState();
  const [ siteInFocus, setSiteInFocus ] = useState();

  const sites = getAllSites();
  const shouldHide = location.pathname.startsWith('/account');
  const [visible, setVisible] = useState(true);
  const [animatingOut, setAnimatingOut] = useState(false);

  useEffect(() => {
    if (shouldHide) {
      setAnimatingOut(true);
      // Wait for transition to finish before hiding
      const timeout = setTimeout(() => {
        setVisible(false);
        setAnimatingOut(false);
      }, 300); // match transition duration
      return () => clearTimeout(timeout);
    } else {
      setVisible(true);
      setAnimatingOut(false);
    }
  }, [shouldHide]);

  useEffect(() => {
    if (parentIsLoading) return;
    const siteId = getSiteIdFromUrl(location.pathname)
    loadSite(siteId)
  }, [location, parentIsLoading])

  const handleProfileMenuOpen = event => {
    setAnchorEl(event.currentTarget)
  };

  const handleOpenDrawer = event => {
    
    // setIsDrawerOpen(true)
    MenuStore.setIsDrawerOpen(true);
  };

  const handleMenuClose = () => {
    setAnchorEl(null)
  };

  const handleSignUserOut = () => {
    signUserOut();
    handleMenuClose();
    history.push('/');
  };

  const getFirstName = () => (
    getUserObject() && `${getUserObject().user_personal.first_name}`
  )

  const getLastName = () => (
    getUserObject() && `${getUserObject().user_personal.last_name}`
  )

  const getUserEmail = () => (
    getUserObject() && `${getUserObject().user_login_id}`
  )

  const isUserAdmin = () => {
    const user = getUserObject();
    return user && user.user_security && user.user_security.is_admin;
  }

  const handleDashboardClick = () =>  { history.push('/dashboard'); handleMenuClose(); }
  const handleAccountClick = () =>  { history.push('/account/me'); handleMenuClose(); }
  // const handleLocationsClick = () => { history.push('/account/locations'); handleMenuClose(); }
  const handleAdminClick = () => { history.push('/admin'); handleMenuClose(); }
  const handleLinkClick = (link) => { handleMenuClose(); history.push(link); }

  const loadSite = async (siteId) => {
    if (!siteId && siteInFocus) {
      setSiteInFocus(undefined)
      return
    } else if (!siteId) return;
    try {
      setIsLoadingSite(true)
      const site = await getSiteByIdForUser(siteId, getUserId());
      setSiteInFocus(site)
    } catch(err) {
      console.error(err)
    } finally {
      setIsLoadingSite(false)
    }
  }

  const getSiteIdFromUrl = (url) => {
    const lookFor = 'site/'
    const startIndex = url.indexOf(lookFor)
    if (startIndex < 0) return;
    let siteId = url.slice(startIndex + lookFor.length)
    let end = siteId.indexOf('/')
    if (end < 0) return siteId
    siteId = siteId.slice(0, siteId.indexOf('/'))
    return siteId;
  }

  const renderTestTag = () => (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: '#f00',
        padding: 8,
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 8,
        fontSize: 12,
        color: '#fff',
        zIndex: 1000
      }}
    >
      {getEnv().toUpperCase()}{getEnv().toUpperCase() === 'LOCAL' && ` ${getLocalEnv()}`} ENV
    </div>
  )

  const renderWebsiteMenu = () => {
    if (!sites) return <></>;
  
    const hasSites = sites.length > 0;
    const isAdmin = isUserAdmin();

    
  
    return (
      <Menu
        anchorEl={anchorEl}
        open={anchorEl}
        onClose={handleMenuClose}
        keepMounted
        sx={{ PROFILE_FONT_STYLE }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {!hasSites && (
          <MenuItem
            onClick={() => handleLinkClick('/account/setup')}
            sx={{
              backgroundColor: '#e6f5ea',
              borderRadius: '6px',
              mx: 1,
              mt: 1,
              mb: 2,
              '&:hover': {
                backgroundColor: '#d1f0de',
              },
            }}
          >
            <ListItemIcon sx={{ marginRight: '8px' }}>
              <StoreOutlined sx={{ fontSize: '22px', color: '#2e7d32' }} />
            </ListItemIcon>
            <ListItemText
              primary="Get Set Up"
              secondary="Create your first website"
              primaryTypographyProps={{ fontSize: '18px', fontWeight: 'bold', color: '#2e7d32' }}
              secondaryTypographyProps={{ fontSize: '13px', color: '#4b5b4f' }}
            />
          </MenuItem>
        )}
  
        {hasSites &&
          sites.map((site) => (
            <MenuItem
              key={site.site_id}
              onClick={() => handleLinkClick(`/dashboard/site/${site.site_id}`)}
            >
              <ListItemIcon sx={{ marginRight: '0px' }}>
                <Avatar
                  src={
                    site.site_details && site.site_details.site_img_url
                      ? site.site_details.site_img_url
                      : ''
                  }
                  alt={site.name}
                  sx={{ height: '20px', width: '20px' }}
                >
                  <StoreOutlined sx={{ fontSize: '16px' }} />
                </Avatar>
              </ListItemIcon>
              <ListItemText
                primary={
                  site.site_details && site.site_details.site_name
                    ? site.site_details.site_name
                    : 'Untitled Site'
                }
                primaryTypographyProps={{ fontSize: '18px' }}
              />
            </MenuItem>
          ))}
  
        <Divider />
  
        <div
          style={{
            paddingLeft: '18px',
            paddingRight: '18px',
            paddingTop: '10px',
            paddingBottom: '10px',
            ...PROFILE_FONT_STYLE,
          }}
        >
          <h4 style={{ margin: 0, fontSize: 18, fontWeight: 'normal' }}>
            {getFirstName()} {getLastName()}
          </h4>
          <p style={{ margin: 0, fontSize: 14 }}>{getUserEmail()}</p>
        </div>
  
        <MenuItem onClick={handleAccountClick}>
          <ListItemText
            primary="Manage Account"
            primaryTypographyProps={{ fontSize: '18px' }}
          />
        </MenuItem>

        {isAdmin &&
          <MenuItem onClick={handleAdminClick}>
            <ListItemText
              primary="Team Panel"
              primaryTypographyProps={{ fontSize: '18px' }}
            />
          </MenuItem>
        }
  
        <MenuItem onClick={handleSignUserOut}>
          <ListItemText
            primary="Log Out"
            primaryTypographyProps={{ fontSize: '18px' }}
          />
        </MenuItem>
      </Menu>
    );
  };
  
  const renderProfileWidget = () => {
    if (!sites || parentIsLoading) {
      return (
        <Skeleton height={55} width={125} />
      )
    }

    let avatar = !siteInFocus ?  
      <><AccountCircle style={{ fontSize: 24, marginRight: 4 }}/> {getFirstName()}</>
    :
    (<><Avatar src={(siteInFocus.site_details && siteInFocus.site_details.site_img_url) || ''} alt={siteInFocus.site_details.site_name} sx={{ height: '30px', width: '30px', marginRight: '8px'}}>
      <StoreOutlined sx={{ fontSize: '22px' }} />
    </Avatar>{siteInFocus.site_details.site_name}</>);

    return (
      <Button
        aria-owns={anchorEl ? 'material-appbar' : undefined}
        aria-haspopup="true"
        onClick={handleProfileMenuOpen}
        color="inherit"
        style={{ textTransform : 'none', color: '#333' }}
      >
        {avatar}
      </Button>
    )
  }

 

  return (
    <div style={{ marginTop: '70px' }}>
      <AppBar position="fixed" elevation={3} sx={{ backgroundColor: '#fff', height: INTERNAL_HEADER_HEIGHT, paddingTop: '5px', zIndex: 1300 }}>
        { getEnv() !== "PROD" && renderTestTag() }
        <Toolbar>
          {(visible || animatingOut) &&
          <MobileBox
            sx={{
              mr: 1,
              transition: 'opacity 0.3s ease, transform 0.3s ease',
              opacity: shouldHide ? 0 : 1,
              transform: shouldHide ? 'scale(0.95)' : 'scale(1)',
              pointerEvents: shouldHide ? 'none' : 'auto',
              display: (visible || animatingOut) ? 'flex' : 'none',
            }}
          >
            <IconButton
              onClick={handleOpenDrawer}
              color="inherit"
            >
              <MenuIcon style={{ fontSize: 24, color: '#000' }} />
            </IconButton>
          </MobileBox>
          }
          
          <Box sx={{ flexGrow: 1, marginTop: { xs: '7px', sm: '0px' } }}>
            <StyledLogo onClick={handleDashboardClick} />
          </Box>
          <DesktopBox sx={{ flexGrow: 1, display: { sm: 'none', md: 'flex' }, justifyContent: 'flex-end' }}>
            {renderProfileWidget()}
          </DesktopBox>
          <MobileBox sx={{ flexGrow: 1, justifyContent: 'flex-end' }}>
            <IconButton
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircle style={{ fontSize: 24, color: '#000' }}/>
            </IconButton>
          </MobileBox>
        </Toolbar>
      </AppBar>
      {renderWebsiteMenu()}
    </div>
  )
}

export default withRouter(InternalHeader);
